
















import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Frekuensi extends Vue {
  @Prop() setFrekuensi: string;
  @Prop() setLabel!: string;
  label = "";
  placeholder = this.setLabel;
  validasi = [(v) => this.cek()];
  // frekuensi = null;

  // @Watch("frekuensi")
  // changeFrekuensi(val) {
  //   this.$emit("frekuensi", val);
  // }
  mounted() {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (this.setFrekuensi == "" || this.setFrekuensi == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
  }
  @Watch("setFrekuensi")
  valFrekuensi(val) {
    if (this.setLabel == "") {
      this.label = "";
      this.placeholder = "";
    } else {
      if (val == "" || val == null) {
        this.label = "";
        this.placeholder = this.setLabel;
      } else {
        this.label = this.setLabel;
        this.placeholder = "";
      }
    }
    this.$emit("frekuensi", val);
    this.setFrekuensi = val;
  }
  cek() {
    if (this.setFrekuensi) {
      if (isNaN(Number(this.setFrekuensi)))
        this.setFrekuensi = this.setFrekuensi.substring(
          0,
          this.setFrekuensi.length - 1
        );
    }
    return true;
  }
}
